import { render, staticRenderFns } from "./StudentAvailabilityWeekDisplay.vue?vue&type=template&id=c8e9c192&scoped=true"
import script from "./StudentAvailabilityWeekDisplay.vue?vue&type=script&lang=js"
export * from "./StudentAvailabilityWeekDisplay.vue?vue&type=script&lang=js"
import style0 from "./StudentAvailabilityWeekDisplay.vue?vue&type=style&index=0&id=c8e9c192&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8e9c192",
  null
  
)

export default component.exports